import Image from "next/image";
import heroImg from "@/img/jobs-couch-bg.jpg";

function Landing() {
  return (
    <header className="padded-box intro">
      <div className="gradient-bg">
        <Image
          src={heroImg}
          alt="Two Watershed employees sitting on a couch at the San Francisco office, happily looking at a laptop"
          objectFit="cover"
          objectPosition="center"
          placeholder="blur"
          draggable={false}
        />
      </div>
      <div className="left">
        <h2>Work at Watershed</h2>
        <h3>
          Climate change is an urgent problem with a multitude of ways to
          contribute. At Watershed, you can maximize your impact on the fight
          against climate change while focusing your day-to-day work on what you
          do best.
        </h3>
        <p>
          We believe companies are critical actors in the race to get the
          world's emissions to net zero, and we measure our success in the
          tonnes of emissions prevented by our customers. If the intersection of
          technology and climate interests you, please get in touch.
        </p>
        <p>
          We’re backed by investors and advisors including Sequoia, Kleiner
          Perkins, Al Gore, Mark Carney, Christiana Figueres, John & Patrick
          Collison, and Laurene Powell Jobs.
        </p>
      </div>
      <style jsx>{`
        .left p {
          color: #ffffff;
        }
        .left h3 {
          color: #ffffff;
          font-weight: 500;
          font-size: 22px;
        }
        .intro {
          display: flex;
          align-items: center;
          justify-content: space-between;
          border-radius: 16px;
          padding-top: 80px;
          padding-bottom: 80px;
          position: relative;
          background: #241f19;
          overflow: hidden;
          color: rgba(255, 255, 255, 0.7);
        }
        .gradient-bg {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background-color: #241f19;
          z-index: 0;
          mask-image: linear-gradient(to right, transparent 25%, black 100%);
          -webkit-mask-image: linear-gradient(
            to right,
            transparent 0px,
            rgba(0, 0, 0, 0.3) 440px,
            black 900px
          );
        }
        .gradient-bg > :global(span) {
          height: 100%;
        }
        .left {
          max-width: 560px;
          margin-right: 64px;
          z-index: 1;
        }
        p {
          color: inherit;
        }
        h2,
        a {
          color: #fff;
        }
        .investors {
          padding-top: 24px;
          padding-right: 24px;
          display: flex;
          align-items: center;
          justify-content: space-between;
        }
        @media screen and (max-width: 820px) {
          .intro {
            flex-direction: column;
            align-items: flex-start;
            padding-top: 24px;
            padding-bottom: 24px;
          }
          .left {
            margin-right: 0;
          }
          .investors {
            flex-direction: column;
            align-items: flex-start;
            padding-top: 0;
          }
          .investors > div {
            margin-top: 8px;
          }
        }
      `}</style>
    </header>
  );
}

export default Landing;
